import React from 'react';
import AsyncCreatableSelect from 'react-select/async-creatable';
import { getSuppliers } from '../../services/supplierService';

// Fetch matching or default suppliers from API
const loadOptions = async (inputValue) => {
  try {
    const searchParam = inputValue && inputValue.trim() ? inputValue.trim() : undefined;
    const result = await getSuppliers({ page: 1, pageSize: 100, search: searchParam });

    // Unwrap array from API response envelope
    const items = Array.isArray(result)
      ? result
      : (result?.data ?? result?.items ?? []);

    const options = items
      .map((s) => {
        const name = s.supplierName || s.name || s.exporter;
        return name ? { value: name, label: name, supplier: s } : null;
      })
      .filter(Boolean);

    return options;
  } catch (error) {
    console.error('Failed to load suppliers for Exporter dropdown:', error);
    return [];
  }
};

/**
 * ExporterSearchDropdown — Production-grade searchable & creatable dropdown for Exporter
 * Preloads existing suppliers on click and passes selected supplier object to parent.
 */
const ExporterSearchDropdown = ({ value, onChange, onBlur, placeholder = 'Exporter', id }) => {
  return (
    <AsyncCreatableSelect
      inputId={id}
      value={value ? { value, label: value } : null}
      loadOptions={loadOptions}
      defaultOptions={true} // Load initial supplier list immediately on focus/click
      onChange={(opt) => onChange(opt ? opt.value : '', opt ? opt.supplier : null)}
      onBlur={onBlur}
      placeholder={placeholder}
      isClearable
      cacheOptions
      formatCreateLabel={(txt) => `+ Add "${txt}"`}
      noOptionsMessage={({ inputValue }) =>
        inputValue ? 'No suppliers found' : 'No suppliers available'
      }
      loadingMessage={() => 'Loading suppliers...'}
      styles={{
        control: (base, state) => ({
          ...base,
          minHeight: '38px',
          fontSize: '14px',
          borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
          boxShadow: 'none',
          borderRadius: '6px',
          '&:hover': { borderColor: '#86b7fe' },
        }),
        menu: (base) => ({
          ...base,
          zIndex: 9999,
          borderRadius: '6px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        }),
        option: (base, state) => ({
          ...base,
          fontSize: '13.5px',
          backgroundColor: state.isSelected
            ? '#0d6efd'
            : state.isFocused
            ? '#e8f0fb'
            : '#fff',
          color: state.isSelected ? '#fff' : '#212529',
          cursor: 'pointer',
        }),
        placeholder: (base) => ({ ...base, color: '#6c757d', fontSize: '14px' }),
        dropdownIndicator: (base) => ({
          ...base,
          color: '#6c757d',
          padding: '4px 8px',
          '&:hover': { color: '#212529' },
        }),
        indicatorSeparator: () => ({ display: 'none' }),
      }}
    />
  );
};

export default ExporterSearchDropdown;
